// extracted by mini-css-extract-plugin
module.exports = {"emoji-picker":"EmojiPicker_emoji-picker__wx2xi","emoji-picker__animation":"EmojiPicker_emoji-picker__animation__61e10","emoji-animation":"EmojiPicker_emoji-animation__Y1qRX"};